<div class="metering-point-item__metering-wrapper">
  <div>
    <h2 class="h3" id="page_subtitle">{{'metering.item.metering.title'|translate}}</h2>
  </div>

  <div class="metering-point-item__metering-buttons">
  <div class="metering-point-item__metering-buttons-wrapper">
    <div class="metering-point-item__metering-buttons--row">
      <div class="sxl-flex sxl-items-center sxl-justify-start">
        <div>
          <div class="metering-point-item__metering-form__label">{{'metering.item.metering.selected-period'|translate}}</div>
          <mat-button-toggle-group (change)="onPeriodChanged($event)" [value]="'Day'">
            <mat-button-toggle value="Month" id="month_btn">{{"metering.item.metering.period_month"| translate}}</mat-button-toggle>
            <mat-button-toggle value="Day" id="day_btn">{{"metering.item.metering.period_day"| translate}}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <div class="sx-contract-item__wrapper--wide-button sxl-items-center sxl-justify-end">
        <button mat-button class="mat-button sx-button sx-button--icon sx-button--icon-scale-medium" id="reading_export_btn" [disabled]="isExporting" (click)="export()">
          <app-spinner [showSmall]="'true'" [hidden]="!isExporting"></app-spinner>
          <svg>
            <use xlink:href="#sx-excel" href="#sx-excel" />
          </svg>
          {{'core.button.export' | translate}}
        </button>
      </div>

    </div>
  </div>
  </div>

  <div [hidden]="meteringPoint.type !== 'LOG'" class="metering-point-item__metering-form">
    <div>
      <div class="metering-point-item__metering-form__label">{{'metering.item.metering.selected-mp'|translate}}</div>
      <mat-form-field class="metering-point-item__metering-form--select">
        <mat-select [value]="selectedMeteringPoint" (selectionChange)="subMeteringPointChanged($event)">
          <mat-option [value]="y" *ngFor="let y of meteringPoint.containedMeteringPoints">
            <span class="sxh-capitalize">{{y.name}} </span><span class="sxh-text-mp-id">({{y.id}})</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div [hidden]="meteringPoint.type === 'LOG'" *ngIf="!meteringPoint.readingsLoaded && meteringPoint.readingsLoading">
    <app-spinner title="{{'metering.item.metering.loading'|translate}}"></app-spinner>
  </div>
  <div [hidden]="meteringPoint.type !== 'LOG'"
    *ngIf="!selectedMeteringPoint.readingsLoaded && selectedMeteringPoint.readingsLoading">
    <app-spinner title="{{'metering.item.metering.loading'|translate}}"></app-spinner>
  </div>
  <div class="metering-point-item__table"
    [hidden]="!(((selectedMeteringPoint.readingsLoaded && meteringPoint.type === 'LOG') || (meteringPoint.readingsLoaded && meteringPoint.type !== 'LOG')) && readings && readings.length > 0)">
    <table mat-table matSort [dataSource]="dataSource" id="readings_list">

      <ng-container matColumnDef="timestamp" sticky>
        <mat-header-cell mat-sort-header *matHeaderCellDef id="col_timestamp"
          class="metering-point-item__table--head metering-point-item__table--head-timestamp">
          {{'metering.item.metering.column-date' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element; let i=index" id="readings_timestamp_{{i}}"
          class="metering-point-item__table--col metering-point-item__table--col-timestamp">
          <span class="mobile-label">{{'metering.item.metering.column-date' | translate}}:</span>
          <span class="sxh-span__nowrap">{{element.timeStamp | date: 'yyyy-MM-dd' : 'CET': 'sv'}} </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <mat-header-cell mat-sort-header *matHeaderCellDef id="col_quantity"
          class="metering-point-item__table--head metering-point-item__table--head-quantity">
          {{'metering.item.metering.column-meter' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element; let i=index" id="readings_quantity_{{i}}"
          class="metering-point-item__table--col metering-point-item__table--col-quantity">
          <span class="mobile-label"> {{'metering.item.metering.column-meter' | translate}}:</span>
          <span class="sxh-span__nowrap">{{element.quantity | number:'1.3-3': 'sv'}} {{'metering.item.metering.mwh' | translate}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="statusName">
        <mat-header-cell mat-sort-header *matHeaderCellDef id="col_status"
          class="metering-point-item__table--head metering-point-item__table--head-status">
          {{'metering.item.metering.column-status' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element; let i=index" id="readings_status_{{i}}"
          class="metering-point-item__table--col metering-point-item__table--col-status"> 
          <span class="mobile-label"> {{'metering.item.metering.column-status' | translate}}:</span>
          <span class="sxh-span__nowrap">{{element.statusName}}</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayColumns;let i=index" id="readings_row_{{i}}"></mat-row>
    </table>

    <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="25" id="readings_paginator"
      [pageSizeOptions]="[10, 25, 50, 100, 250]">
    </mat-paginator>

  </div>
  <div *ngIf="selectedMeteringPoint.readingsLoaded && readings.length ===0">
    <app-no-content [displayText]="('metering.item.metering.empty' | translate)"></app-no-content>
  </div>

</div>
